<template>
  <div class="video_rich_ranking">

    <van-row>
      <van-col span="24" class="video_rich_ranking_top">
        <van-col span="18" offset="3" class="video_rich_ranking_top_card">
          <van-tabs type="card" background="#9e3dfc" color="#ffffff" title-active-color="#7734FE" title-inactive-color="#ffffff" v-model="active" @click="onClickTabs">
            <van-tab :title="$t('column.Yesterday_list')"></van-tab>
            <van-tab :title="$t('column.Today_List')"></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="20" offset="2" class="video_rich_ranking_type">
          <!-- 第2名 -->
          <van-col span="7" class="video_rich_ranking_type1">
            <van-image
              width="100%"
              height="100"
              :src="video_ranking_list_top2"
            />
            <div class="video_rich_ranking_type_avatar">
              <van-image
                round
                width="45"
                height="45"
                fit="cover"
                :src="list[1]['head_image']"
                v-if="list.length > 1"
              />
            </div>
            <div class="video_rich_ranking_type_img">
              <van-image
                width="60"
                :src="video_ranking_list_avatar2"
              />
            </div>
            <div class="video_rich_ranking_type_div" v-if="list.length > 1">
              <van-col span="24" class="video_rich_ranking_type_div_name">
                {{ list[1].nick_name }}
                <img :src="list[1]['sex'] === 1 ? sex1 : sex2"/>
              </van-col>
              <van-col span="24" class="video_rich_ranking_type_div_level">
                <img :src="list[1].user_level_url"/>
              </van-col>
              <van-col span="24" class="video_rich_ranking_type_div_ticket"> {{ list[1].ticket }} <img :src="xin"/></van-col>
            </div>
          </van-col>
          <!-- 第1名 -->
          <van-col span="10" class="video_rich_ranking_type2">
            <van-image
              width="100%"
              height="130"
              :src="video_ranking_list_top1"
            />
            <div class="video_rich_ranking_type_avatar">
              <van-image
                round
                width="45"
                height="45"
                fit="cover"
                :src="list[0]['head_image']"
                v-if="list.length"
              />
            </div>
            <div class="video_rich_ranking_type1_img">
              <van-image
                width="100"
                :src="video_ranking_list_avatar1"
              />
            </div>
            <div class="video_rich_ranking_type_div" v-if="list.length">
              <van-col span="24" class="video_rich_ranking_type_div_name" style="margin-top: 2vh;">
                {{ list[0].nick_name }}
                <img :src="list[0]['sex'] === 1 ? sex1 : sex2"/>
              </van-col>
              <van-col span="24" class="video_rich_ranking_type_div_level">
                <img :src="list[0].user_level_url"/>
              </van-col>
              <van-col span="24" class="video_rich_ranking_type_div_ticket"> {{ list[0].ticket }} <img :src="xin"/></van-col>
            </div>
          </van-col>
<!-- 第三名 -->

          <van-col span="7" class="video_rich_ranking_type3">
            <van-image
              width="100%"
              height="100"
              :src="video_ranking_list_top3"
            />
            <div class="video_rich_ranking_type_avatar">
              <van-image
                round
                width="45"
                height="45"
                fit="cover"
                :src="list[2]['head_image']"
                v-if="list.length > 2"
              />
            </div>

            <div class="video_rich_ranking_type_img">
              <van-image
                width="60"
                :src="video_ranking_list_avatar3"
              />
            </div>
            <div class="video_rich_ranking_type_div" v-if="list.length > 2">
              <van-col span="24" class="video_rich_ranking_type_div_name">
                {{ list[2].nick_name }}
                <img :src="list[2]['sex'] === 1 ? sex1 : sex2"/>
              </van-col>
              <van-col span="24" class="video_rich_ranking_type_div_level">
                <img :src="list[2].user_level_url"/>
              </van-col>
              <van-col span="24" class="video_rich_ranking_type_div_ticket"> {{ list[2].ticket }} <img :src="xin"/></van-col>
            </div>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="24" class="video_rich_ranking_list">
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            :loading-text="$t('other.Loading')"
            @load="onLoad"
            style="padding-bottom: 6vh"
          >
            <van-cell v-for="(item,i) in list" :key="i" v-if="i > 2">
              <van-col span="2" class="video_rich_ranking_type_list_i">{{ i + 1 }}</van-col>
              <van-col span="4" class="video_rich_ranking_type_list_avatar">
                <van-image
                  round
                  width="45"
                  height="45"
                  fit="cover"
                  :src="item.head_image"
                />
              </van-col>
              <van-col span="13" >
                <van-col span="24" class="video_rich_ranking_type_list_name">
                  {{ item.nick_name }}
                  <img :src="item.sex === 1 ? sex1 : sex2"/>
                </van-col>
                <van-col span="24" class="video_rich_ranking_type_list_level">
                  <img :src="item.user_level_url"/>
                </van-col>
              </van-col>
              <van-col span="5" class="video_rich_ranking_refresh_sum"> {{ item.ticket }} <img :src="xin"/></van-col>
            </van-cell>
          </van-list>
      </van-col>
      <van-col span="24" class="video_rich_ranking_bottom">
        <van-col span="3" class="video_rich_ranking_bottom_i">{{ user.order > 0 ? user.order : '99+'}}</van-col>
        <van-col span="4" class="video_rich_ranking_bottom_avatar">
          <van-image
            round
            width="6vh"
            height="6vh"
            fit="cover"
            :src="user.head_image"
          />
        </van-col>
        <van-col span="12" >
          <van-col span="24" class="video_rich_ranking_bottom_name">
            {{ user.nick_name }}
            <img :src="sex1"/>
          </van-col>
          <van-col span="24" class="video_rich_ranking_bottom_level">
            <img :src="user.user_level_url"/>
          </van-col>
        </van-col>
        <van-col span="5" class="video_rich_ranking_bottom_sum"> {{ user.ticket }} <img :src="xin"/></van-col>
      </van-col>
    </van-row>

  </div>
</template>

<script>

  import '@/assets/css/style.css'
  import axios from "axios";
  import {Toast} from "vant";

  export default {
    data() {
      return {
        video_ranking_list_top2: require('../assets/img/video_ranking_list_top2.png'),
        video_ranking_list_top1: require('../assets/img/video_ranking_list_top1.png'),
        video_ranking_list_top3: require('../assets/img/video_ranking_list_top3.png'),
        video_ranking_list_avatar1: require('../assets/img/video_ranking_list_avatar1.png'),
        video_ranking_list_avatar2: require('../assets/img/video_ranking_list_avatar2.png'),
        video_ranking_list_avatar3: require('../assets/img/video_ranking_list_avatar3.png'),
        sex1: require('../assets/img/sex1.png'),
        sex2: require('../assets/img/sex2.png'),
        xin: require('../assets/img/xin.png'),
        active: 1,
        list: [],
        user: {},
        to_uid: undefined,
        room_id: undefined,
        loading: false,
        finished: false,
        refreshing: false,
        publicPath: process.env.BASE_URL
      }
    },
    created: function () {
      this.to_uid = this.$route.query.to_uid
      this.room_id = this.$route.query.room_id
      this.convert()
      document.title = this.$t('column.ranking')
    },
    methods: {
      onClickTabs(name, title) {
        this.active = name
        this.convert()
      },
      onLoad() {},
      onRefresh() {
        // 清空列表数据
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.convert();
      },
      convert() {
        this.loading = true
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=rank&act=video_ranking", {
          params : {
            token: token,
            to_uid: this.to_uid,
            room_id: this.room_id,
            type: this.active,
            page: this.page
          }
        }).then(res =>{
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }
          this.loading = false

          this.list = []
          for(let i = 0; i< res.data.data.list.length; i ++) {
            res.data.data.list[i]['user_level_url'] =  require('../assets/img/rank_'+res.data.data.list[i].user_level+'.png')
            this.list.push(res.data.data.list[i])
          }
          this.user =res.data.data.user
          this.user.user_level_url = require('../assets/img/rank_'+this.user.user_level+'.png')

          this.finished = true
        })
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/video_rich_ranking.vue